import { ChartSettingsBaseDescriptor, StorageItemChartSplitType, StorageItemMovementChartSplitType } from "../etc/types";

/**
 * ancillary helpers for storage charts split types
 */

/*
 Нумерация разбиений у позиций склада и у движений разная, одно и то же число значит разные
 разбиения. Поэтому набор всегда считается по дескриптору графика, а не по одному перечислению.
*/

/** Границы задаются только для числовых разбиений. Склад, ответственный и поле названия числовыми не являются */
export function storageChartSplitHasNumberBorders(
    descriptor: ChartSettingsBaseDescriptor | undefined,
    splitType: number | undefined
): boolean {
    switch (descriptor) {
        case ChartSettingsBaseDescriptor.StorageItemBarChart:
        case ChartSettingsBaseDescriptor.StorageItemPieChart:
            return splitType === StorageItemChartSplitType.TotalAmount ||
                splitType === StorageItemChartSplitType.ItemsQuantity ||
                splitType === StorageItemChartSplitType.FinancialBurden ||
                splitType === StorageItemChartSplitType.SingleItemPrice
        case ChartSettingsBaseDescriptor.StorageItemMovementBarChart:
        case ChartSettingsBaseDescriptor.StorageItemMovementPieChart:
            return splitType === StorageItemMovementChartSplitType.TotalAmount ||
                splitType === StorageItemMovementChartSplitType.ItemsQuantity ||
                splitType === StorageItemMovementChartSplitType.SingleItemPrice
        default:
            return false
    }
}

/** Разбиение по полю названия позиции склада, для него выбирается ссылка на параметр */
export function storageChartSplitIsItemNameField(
    descriptor: ChartSettingsBaseDescriptor | undefined,
    splitType: number | undefined
): boolean {
    switch (descriptor) {
        case ChartSettingsBaseDescriptor.StorageItemBarChart:
        case ChartSettingsBaseDescriptor.StorageItemPieChart:
            return splitType === StorageItemChartSplitType.ItemNameField
        case ChartSettingsBaseDescriptor.StorageItemMovementBarChart:
        case ChartSettingsBaseDescriptor.StorageItemMovementPieChart:
            return splitType === StorageItemMovementChartSplitType.ItemNameField
        default:
            return false
    }
}
